/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'data': {
    width: 21,
    height: 24,
    viewBox: '0 0 21 24',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><ellipse pid="0" _stroke="#000" cx="16.014" cy="1.973" rx="2.002" ry="1.973"/><ellipse pid="1" _stroke="#000" cx="9.939" cy="19.858" rx="2.102" ry="2.071"/><path pid="2" d="M9.794 8.594L14.9 3.277M8.223 13.3l1.205 4.804" _stroke="#000"/><ellipse pid="3" _stroke="#000" cx="17.787" cy="16.592" rx="1.162" ry="1.145"/><ellipse pid="4" _stroke="#000" cx="1.162" cy="14.486" rx="1.162" ry="1.145"/><path pid="5" d="M16.737 16.032l-6.65-3.744M3.007 2.724l2.85 5.617" _stroke="#000"/><ellipse pid="6" _stroke="#008AFF" cx="7.517" cy="10.684" rx="3.242" ry="3.195"/><ellipse pid="7" _stroke="#000" cx="2.587" cy="1.38" rx="1.162" ry="1.145"/></g>'
  }
})
